import { Component, lazy } from 'react';

import { sendGlobalErrorProps } from 'cu-master-layout-prop-manager';

import { Props, State } from './types';

const Page404 = lazy(() => import('@/pages/Page404'));

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  public static getDerivedStateFromError(_: Error): State {
    return {
      hasError: true,
    };
  }

  public componentDidCatch() {
    sendGlobalErrorProps({
      errorType: 'generalError',
    });
  }

  render() {
    return this.state.hasError ? <Page404 /> : this.props.children;
  }
}
